/* eslint-disable react/jsx-curly-newline */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useEffect, useState, useRef } from 'react';
import { change, Field } from 'redux-form';
import { useDispatch, useSelector } from 'react-redux';
import { FormSelectField } from '../../../../semantic-ui/components/form-select-field';
import { CustomDatePicker } from '../../../../semantic-ui/components/custom-datepicker';
import { KgIcon, PieceIcon, VolumeIcon } from '../../../../components/text-icon';
import WeightIcon from '../../../../components/icons/weight-icon.svg';
import CountIcon from '../../../../components/icons/count-icon.svg';
import SizeIcon from '../../../../components/icons/size-icon.svg';
import AddButton from '../../../../components/images/add-button.svg';
import { FormInputField } from '../../../../semantic-ui/components/form-input-field';
import { FormCheckboxField } from '../../../../semantic-ui/components/form-checkbox-field';
import { FormTextAreaField } from '../../../../semantic-ui/components/form-textarea-field';
import { normalizeNumber } from '../../../../utils/normalizeNumber';
import { normalizeInteger } from '../../../../utils/normalizeInteger';
import { ErrorComponent } from '../../../../components/error-component';
import { REQUEST_FORM_NAME } from '../../constants';
import { CustomRequiredComponent } from '../../../../semantic-ui/components/custom-required';

export const PointsComponent = ({
	fields,
	partners,
	onPartnerChange,
	onPartnerSearchChange,
	partnerSearchValue,
	onAddPartnerButtonClick,
	addresses,
	onAddressChange,
	onAddressSearchChange,
	addressSearchValue,
	onAddAddressButtonClick,
	onPointChange,
	contacts,
	onContactChange,
	onContactSearchChange,
	contactSearchValue,
	onAddContactButtonClick,
	isPrr,
	info,
	onPointDelete,
	onPointAdd,
	isAvailablePartners,
	isAvailableAddresses,
	isAvailableContacts,
	seatTypes,
	isOptionsListLoading,
	formValues,
}) => {
	const dispatch = useDispatch();

	const [actionType, setActionType] = useState(null);

	const weight = useSelector(state => state.form[REQUEST_FORM_NAME]?.values?.weight);

	const volume = useSelector(state => state.form[REQUEST_FORM_NAME]?.values?.volume);

	const place = useSelector(state => state.form[REQUEST_FORM_NAME]?.values?.place);

	const prevFieldsLength = useRef(fields.length);

	useEffect(() => {
		if (prevFieldsLength.current < 3 && fields.length === 3 && actionType === 'add') {
			fields.forEach(name => {
				dispatch(change(REQUEST_FORM_NAME, `${name}.weight`, ''));
				dispatch(change(REQUEST_FORM_NAME, `${name}.volume`, ''));
				dispatch(change(REQUEST_FORM_NAME, `${name}.place`, ''));
			});
		}

		if (fields.length === 2) {
			fields.forEach((name, index) => {
				if (index === 0) {
					return;
				}

				const currentField = fields[index];
				if (!currentField?.weight) {
					dispatch(change(REQUEST_FORM_NAME, `${name}.weight`, weight));
				}
				if (!currentField?.volume) {
					dispatch(change(REQUEST_FORM_NAME, `${name}.volume`, volume));
				}
				if (!currentField?.place) {
					dispatch(change(REQUEST_FORM_NAME, `${name}.place`, place));
				}
			});
		}

		// Обновляем предыдущую длину полей
		prevFieldsLength.current = fields.length;
	}, [fields.length, weight, volume, place, actionType]);

	return fields.map((name, index) => {
		// first point is point from, it render outside this component
		if (index === 0) {
			return null;
		}

		return (
			<section className="req-form__section" key={name}>
				<div className="req-form__section-header">
					<h5 className="req-form__header-text">Информация о грузополучателе №{index}</h5>
					{index !== 1 && index === fields.length - 1 && (
						<div
							className="req-form__column_close"
							onClick={() => {
								onPointDelete(index);
								fields.remove(index);
								setActionType('delete');
							}}
						/>
					)}
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">
						Грузополучатель
						<CustomRequiredComponent />
					</div>
					<div
						className={`req-form__field req-form__field_${isAvailablePartners ? 'with' : 'without'}-button`}
					>
						<div className="req-form__field-wrapper">
							<Field
								name={`${name}.partner.id`}
								type="text"
								component={FormSelectField}
								autoComplete="off"
								placeholder="Выберите грузополучателя"
								options={partners[index] || []}
								loading={isOptionsListLoading.partners}
								disabled={isOptionsListLoading.partners}
								noResultsMessage="Грузополучатели не найдены"
								onChange={value => onPartnerChange(value, index)}
								search
								onSearchChange={value => onPartnerSearchChange(value, index)}
								searchValue={partnerSearchValue[index]}
								isWithoutSelectOnBlur
								info={info.partner[index]}
							/>
						</div>
						{isAvailablePartners && (
							<div className="req-form__add-button" onClick={() => onAddPartnerButtonClick(index)} />
						)}
					</div>
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">
						Адрес
						<CustomRequiredComponent />
					</div>
					<div
						className={`req-form__field req-form__field_${
							isAvailableAddresses ? 'with' : 'without'
						}-button`}
					>
						<div className="req-form__field-wrapper">
							<Field
								name={`${name}.address.id`}
								type="text"
								component={FormSelectField}
								autoComplete="off"
								placeholder="Выберите адрес"
								options={addresses[index] || []}
								loading={isOptionsListLoading.addresses[index]}
								disabled={isOptionsListLoading.addresses[index]}
								noResultsMessage={
									formValues?.points?.[index]?.partner?.id
										? 'Адреса не найдены'
										: 'Выберите грузополучателя'
								}
								onChange={value => onAddressChange(value, index)}
								search
								onSearchChange={value => onAddressSearchChange(value, index)}
								searchValue={addressSearchValue[index]}
								isWithoutSelectOnBlur
								info={info.address[index]}
							/>
						</div>{' '}
						{isAvailableAddresses && (
							<div className="req-form__add-button" onClick={() => onAddAddressButtonClick(index)} />
						)}
					</div>
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">
						Дата доставки
						<CustomRequiredComponent />
					</div>
					<div className="req-form__field req-form__date-field">
						<Field
							name={`${name}.date`}
							nameField={`${name}.date`}
							type="text"
							component={CustomDatePicker}
							autoComplete="off"
							onChange={value => onPointChange(value, index, 'date')}
							placeholder=". . / . . / . ."
							dateFormat={['dd.MM.yyyy', 'dd-MM-yyyy', 'dd/MM/yyyy']}
						/>
					</div>
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">
						Контактное лицо
						<CustomRequiredComponent />
					</div>
					<div
						className={`req-form__field req-form__field_${isAvailableContacts ? 'with' : 'without'}-button`}
					>
						<div className="req-form__field-wrapper">
							<Field
								name={`${name}.contact.id`}
								type="text"
								component={FormSelectField}
								autoComplete="off"
								placeholder="Выберите контактное лицо"
								options={contacts[index] || []}
								loading={isOptionsListLoading.contacts}
								disabled={isOptionsListLoading.contacts}
								noResultsMessage={
									formValues?.points?.[index]?.address?.id
										? 'Контактные лица не найдены'
										: 'Выберите адрес'
								}
								onChange={value => onContactChange(value, index)}
								search
								onSearchChange={value => onContactSearchChange(value, index)}
								searchValue={contactSearchValue[index]}
								isWithoutSelectOnBlur
								info={info.contact[index]}
							/>
						</div>
						{isAvailableContacts && (
							<div className="req-form__add-button" onClick={() => onAddContactButtonClick(index)} />
						)}
					</div>
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">Тип места</div>
					<div className="req-form__field">
						<Field
							name={`${name}.type_seat_id`}
							type="text"
							component={FormSelectField}
							autoComplete="off"
							placeholder="Выберите тип места"
							options={seatTypes}
							loading={isOptionsListLoading.seatTypes}
							disabled={isOptionsListLoading.seatTypes}
							noResultsMessage="Типы места не найдены"
							search
							isWithoutSelectOnBlur
							onChange={e => onPointChange(e, 'type_seat_id', index)}
						/>
					</div>
				</div>
				<div className="req-form__row">
					<div className="req-form__text req-form__text_right">
						Габаритные характеристики
						<CustomRequiredComponent />
					</div>
					<div className="req-form__row-with-icons">
						<div className="req-form__column">
							<div className="req-form__cargo-field">
								<img src={WeightIcon} alt="weight-icon" />
								<div className="req-form__field_small">
									<Field
										name={`${name}.weight`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={KgIcon}
										placeholder="Масса"
										onChange={e => onPointChange(normalizeNumber(e.target.value), index, 'weight')}
										isWithoutErrorText
									/>
								</div>
							</div>
						</div>
						<div className="req-form__column">
							<div className="req-form__cargo-field">
								<img src={SizeIcon} alt="weight-icon" />
								<div className="req-form__field_small">
									<Field
										name={`${name}.volume`}
										type="text"
										normalize={normalizeNumber}
										component={FormInputField}
										autoComplete="off"
										icon={VolumeIcon}
										placeholder="Объем"
										onChange={e => onPointChange(normalizeNumber(e.target.value), index, 'volume')}
										isWithoutErrorText
									/>
								</div>
							</div>
						</div>
						<div className="req-form__column">
							<div className="req-form__cargo-field">
								<img src={CountIcon} alt="count-icon" />
								<div className="req-form__field_small">
									<Field
										name={`${name}.place`}
										type="text"
										normalize={normalizeInteger}
										component={FormInputField}
										autoComplete="off"
										icon={PieceIcon}
										placeholder="Места"
										onChange={e => onPointChange(normalizeInteger(e.target.value), index, 'place')}
										isWithoutErrorText
									/>
								</div>
							</div>
						</div>
					</div>
				</div>
				<div className="req-form__row__error">
					<Field name={`${name}.weight`} component={ErrorComponent} />
					<Field name={`${name}.volume`} component={ErrorComponent} />
					<Field name={`${name}.place`} component={ErrorComponent} />
				</div>
				<div className="req-form__row">
					<span className="req-form__text req-form__text_right" />
					<div className="req-form__checkbox">
						<Field
							name={`${name}.is_prr`}
							component={FormCheckboxField}
							toggle
							type="checkbox"
							onChange={value => onPointChange(value, index, 'is_prr')}
						/>
					</div>
					<span className="req-form__label">Требуются погрузочно разгрузочные работы (ПРР)</span>
				</div>
				<div className="req-form__row">
					<span className="req-form__text req-form__text_right">Примечание к ПРР</span>
					<div className="req-form__field">
						<Field
							name={`${name}.description`}
							type="text"
							component={FormTextAreaField}
							autoComplete="off"
							placeholder="Укажите примечание к ПРР"
							width="100%"
							resize="vertical"
							disabled={!isPrr.points[index]}
							onChange={e => onPointChange(e.target.value, index, 'description')}
						/>
					</div>
				</div>
				{index === fields.length - 1 && (
					<div className="req-form__button-row">
						<div className="req-form__button-row-text">Добавить точку доставки</div>
						<img
							src={AddButton}
							alt="add-button"
							onClick={() => {
								onPointAdd(fields);
								setActionType('add');
							}}
						/>
					</div>
				)}
			</section>
		);
	});
};
